import type { Middleware, UnknownAction } from 'redux';
import Tracker from 'utils/analytics/tracker';

type AuthStateChangedAction = UnknownAction & {
  type: 'AUTH_STATE_CHANGED';
  payload?: {
    uid?: string;
    email?: string;
  };
};

export const middleware: Middleware = () => {
  return (next) => {
    return (action: UnknownAction) => {
      switch (action.type) {
        case 'AUTH_STATE_CHANGED': {
          const payload = (action as AuthStateChangedAction).payload || {};
          Tracker.set({ userId: payload.uid });
          break;
        }
        default:
          break;
      }
      return next(action);
    };
  };
};

export default middleware;
